import { render, staticRenderFns } from "./identificationList.vue?vue&type=template&id=734a7012&scoped=true&"
import script from "./identificationList.vue?vue&type=script&lang=js&"
export * from "./identificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734a7012",
  null
  
)

export default component.exports